import { render } from "./InputComponent.vue?vue&type=template&id=47bc7baf&ts=true"
import script from "./InputComponent.vue?vue&type=script&lang=ts"
export * from "./InputComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__